import { render } from "./WebsiteProductReviewCreated.vue?vue&type=template&id=f88000b6"
import script from "./WebsiteProductReviewCreated.vue?vue&type=script&lang=js"
export * from "./WebsiteProductReviewCreated.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__